import { GetterTree } from 'vuex'
import { BatteryRechargingCapacityState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<BatteryRechargingCapacityState, RootState> = {
}
